import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import mixpanel from '../utils/mixpanel';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    mixpanel.track('page_viewed', {
      page: location.pathname,
    });
  }, [location]);
};

export default usePageTracking;
